import VueRouter from 'vue-router';
import MainLayout from '@/layout/MainLayout.vue';
const Home = () => import('./views/home/Home');
const About = () => import('./views/About');
const Login = () => import('./views/login/LoginWrap');
const Register = () => import('./views/register/RegisterWrap');
const FindPasw = () => import('./views/register/FindPasw');
const ChangePasw = () => import('./views/register/ChangePasw');
const Calculate = () => import('./views/calculate/Calculate');
const Send = () => import('./views/send/Send');
const Order = () => import('./views/order/Order');
const Profile = () => import('./views/profile/Profile');
const User = () => import('./views/User');
const ErrPage = () => import('./views/Error');

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/find-password',
      name: 'find-password',
      component: FindPasw,
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: ChangePasw,
    },
    {
      path: '/calculate',
      name: 'calculate',
      component: Calculate,
    },
    {
      path: '/send/:orderNumber',
      name: 'send',
      component: Send,
      meta: {
        keepAlive: true, // 需要被缓存
      },
    },
    {
      path: '/user',
      component: User,
      children: [
        {
          path: 'order',
          name: 'order',
          component: Order,
        },
        {
          path: 'profile',
          name: 'profile',
          component: Profile,
        },
      ],
    },
    // {
    //   path: '/failed-bill/:orderNumber',
    //   name: 'failed-bill',
    //   component: FailedBill,
    // },
    {
      path: '/failed-bill',
      component: MainLayout,
      name: 'dashboard',
      alwaysShow: true,
      redirect: '/dashboard/lading',
      children: [
        {
          path: '/failed-bill/:orderNumber',
          name: 'failed-bill',
          component: () => import('@/views/bill/FailedBill.vue'),
        },
      ],
    },
    {
      path: '*',
      component: ErrPage,
    },
  ],
});

export default router;
